export const Constants = {
  reportedErrors: 'erros reportados',
  noreports: 'Não existem erros reportados no momento',
  reportDate: 'data do reporte',
  reportedBy: 'reportado por',
  osNumber: 'número OS',
  client: 'cliente',
  goal: 'objetivo',
  source: 'tipo do erro',
  status: 'status',
  errorDescription: 'descrição do erro',
  reportedError: 'Erro Reportado',
  creation: 'criação',
  findings: 'observações',
  save: 'salvar alterações',
  finish: 'finalizar',
  revision: 'revisão e aprovação',
  propertyData: 'Dados do imóvel',
  propertyAddress: 'Localização do imóvel',
  propertyDetails: 'Características do imóvel',
  scheduleInfo: 'Informações sobre agendamento',
  noInspection: 'esta OS não possui agendamento',
  propertyPhotos: 'Imagens do imóvel',
  noPhotos: 'esta OS não possui imagens',
  noSample: 'esta OS não possui amostra',
  form: 'Formulário',
  noForm: 'esta OS não possui Formulário',
  sample: 'Amostra',
  report: 'Cálculo automatizado',
  noReport: 'Relatório não pode ser criado',
  pdfReport: 'Relatório',
  element: 'elemento',
  privateArea: 'área privativa',
  landArea: 'área do terreno',
  constructedArea: 'área construída:',
  squareMeters: ' m²',
  parkingLots: 'vagas de garagem',
  propertyType: 'tipo de imóvel',
  cep: 'CEP',
  city: 'cidade',
  district: 'bairro',
  address: 'logradouro',
  number: 'número',
  sellingPrice: 'preço de venda',
  real: 'R$ ',
  propertyLink: 'link do imóvel',
  age: 'idade',
  conservation: 'estado de conservação',
  standard: 'padrão construtivo',
  movePin: 'Mova o pin e salve caso a localização esteja incorreta',
  lat: 'latitude:',
  lng: 'longitude:',
  searchMap: 'pesquisar no mapa',
  mapUpdated: 'mapa atualizado',
  fieldsIncomplete: 'Preencha os campos obrigatórios do endereço',
  downloadPdf: 'anúncio em PDF',
  pictures: 'Fotos',
  propertyDescription: 'Descrição do imóvel',
  moreImg: 'Mais imagens',
  acceptCheck:
    'Estou ciente que sou responsável pelos dados acima e os declaro como verdadeiros.',
  removeButton: 'remover elemento da base de dados',
  noErrorButton: 'ausência de erros',
  finishElement: 'inativar elemento',
  finishText: 'O elemento está inativado. Você gostaria de finalizar o ticket?',
};
